import { Provider } from '@angular/core';
import { gtmProvider } from './gtm/gtm.service';
import { mixpanelProvider } from './mixpanel/mixpanel.service';

export const baseProviders: ReadonlyArray<Provider> = [gtmProvider, mixpanelProvider];
